{
  "en": {
    "building": {
      "attributes": {
        "description": "Description",
        "elevators": "Number of elevators",
        "end_date": "End date",
        "floors": "Number of storeys",
        "internal_note": "Building internal note",
        "name": "Name",
        "start_date": "Start date",
        "surface_shared": "Shared space area"
      },
      "labels": {
        "building": "No building | One building | {count} Buildings"
      },
      "toasts": {
        "create": "Building created",
        "delete": "Building deleted",
        "update": "Building updated"
      },
      "validation": {
        "needName": "Title is required",
        "needNumber": "Must be a number (e.g. 85)"
      }
    }
  }
}
